import MiniDrawer from "./components/MiniDrawer";
import Box from "@mui/material/Box";
import CustomAppBar from "./components/CustomAppBar";
import {Outlet} from "react-router-dom";
import {useState, memo, useCallback, useMemo, Suspense} from "react";
import {DRAWER_WIDTH} from "../config/constants";
import Spinner from "../components/Spinner";

const AdminLayout = () => {
    const [open, setOpen] = useState(true);

    const handleDrawerOpen = () => {
        setOpen(true);
    }

    const handleDrawerClose = () => {
        setOpen(false);
    }

    const mainBoxStyle = useMemo(() => ({
        flexGrow: 1,
        p: 3,
        width: `calc(100% - ${DRAWER_WIDTH}px)`
    }), []);

    return (
        <Box sx={{display: 'flex'}}>
            <MiniDrawer
                open={open}
                handleDrawerOpen={handleDrawerOpen}
                handleDrawerClose={handleDrawerClose}
            />

            <CustomAppBar
                open={open}
                handleDrawerOpen={handleDrawerOpen}
            />

            <Box component="main" sx={mainBoxStyle}>
                <div style={{minHeight: "37px"}}/>
                <Suspense fallback={<Spinner/>}>
                    <Outlet/>
                </Suspense>
            </Box>
        </Box>
    );
};

export default AdminLayout;
